<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_ix">CONTENTS</a></p><a id="page_ix">
</a><p class="toc1"><a id="page_ix"></a><a href="#/xhtml/09_Acknowledgement#ack"><span class="small">ACKNOWLEDGMENTS</span></a></p>
<p class="toc"><a href="#/xhtml/11_Introduction#int"><span class="small">INTRODUCTION</span> <i>Set and Setting</i></a></p>
<p class="toc"><span href="#/xhtml/12_Chapter01#ch1" title="Link target outside of Sample"><span class="small">ONE</span> <i>The Myth of the Winchester Goose</i></span></p>
<p class="toc"><span href="#/xhtml/13_Chapter02#ch2" title="Link target outside of Sample"><span class="small">TWO</span> <i>Medieval Bankside</i></span></p>
<p class="toc"><span href="#/xhtml/14_Chapter03#ch3" title="Link target outside of Sample"><span class="small">THREE</span> <i>Shamanism and the Ritual Oscillation of Time</i></span></p>
<p class="toc"><span href="#/xhtml/15_Chapter04#ch4" title="Link target outside of Sample"><span class="small">FOUR</span> <i>The Virgin Queen and the English Nation</i></span></p>
<p class="toc"><span href="#/xhtml/16_Chapter05#ch5" title="Link target outside of Sample"><span class="small">FIVE</span> <i>Southwark, Then and Now</i></span></p>
<p class="toc"><span href="#/xhtml/17_Conclusion#con1" title="Link target outside of Sample"><span class="small">CONCLUSION</span> <i>Making the Present</i></span></p>
<p class="toc1"><span href="#/xhtml/18_Epilogue#epi" title="Link target outside of Sample"><span class="small">EPILOGUE</span> <i>Crossbones Garden</i></span></p>
<p class="toc"><span href="#/xhtml/19_Bm01#bm1" title="Link target outside of Sample"><span class="small">PERMISSIONS FOR TEXT AND PHOTOGRAPHS</span></span></p>
<p class="toc"><span href="#/xhtml/20_Notes#nts" title="Link target outside of Sample"><span class="small">NOTES</span></span></p>
<p class="toc"><span href="#/xhtml/21_Bibliography#bib" title="Link target outside of Sample"><span class="small">BIBLIOGRAPHY</span></span></p>
<p class="toc"><span href="#/xhtml/22_Index01#idx" title="Link target outside of Sample"><span class="small">INDEX</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Contents.vue?248fa2da